import { render, staticRenderFns } from "./userconfigurevipNew.vue?vue&type=template&id=3dabfc68&"
import script from "./userconfigurevipNew.vue?vue&type=script&lang=js&"
export * from "./userconfigurevipNew.vue?vue&type=script&lang=js&"
import style0 from "./userconfigurevipNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports